import { StyleSheet } from 'react-native'
import * as colors from '../../config/colors'
import * as v from '../../config/variables'

const styles = StyleSheet.create({
  container: {},
  centerWrap: {
    alignItems: 'center',
    paddingTop: v.SPACE_LG,
  },
  centerWrapInner: {
    maxWidth: 400,
    paddingHorizontal: v.SPACE_SM,
    width: '100%',
  },
  logo: {
    marginBottom: v.SPACE_LG,
    // width: 200,
    // height: 50
  },
  helpText: {
    color: colors.grayDark,
    textAlign: 'center',
    marginBottom: v.SPACE_MD,
  },
  actionRow: {
    marginVertical: v.SPACE_SM,
  },
  actionText: {
    textAlign: 'center',
  },
  secondaryActionBox: {
    marginVertical: v.SPACE_MD,
  },
})

export default styles
